import React from 'react';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
import $ from 'jquery';
import 'jquery-ui-bundle';
import autoBind from 'react-autobind';

import textUtil from '@common/helpers/text.utils';
import arrayUtils from '@common/helpers/array.utils';

//Context
import { withGridContext } from './grid.factory';

import GridFilter from './grid.filter';

class GridHeader extends React.Component {
  constructor(props) {
    super(props);
    this.refCol = React.createRef();
    this.refFilter = React.createRef();
    this.getDefaultWidths();
    autoBind(this);
  }

  getDefaultWidths() {
    const { context } = this.props;
    const { columns } = context;
    const { index } = this.props;

    let column = columns[index];

    if (!column.width || !column.minWidth) {
      const textWidth = textUtil.getTextWidth(column.fieldName) + 40;
      column.width = column.width || (textWidth < 200 ? 200 : textWidth);
      column.minWidth = textWidth;
      context.setState({ columns });
    }
  }

  onDrop(e, ui) {
    const { context } = this.props;

    let newIndex = $(e.target).data('index');
    let oldIndex = $(ui.draggable).data('index');

    context.setState({ columns: arrayUtils.move(context.columns, oldIndex, newIndex) });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { column } = nextProps;

    //Recaulcula a Largura
    if (this.props.column != column) {
      this.getDefaultWidths();
    }

    //Cria o DragAndDrop quando o Bounds é modificado
    if (nextProps.bounds != this.props.bounds) {
      const { context } = this.props;
      const { hash } = context;
      const acceptHash = ".dynamic-table-header[data-hash='" + hash + "']";
      $(this.refCol.current).draggable({
        helper: function (event) {
          let columnHtml = $(event.target).find('label').first().html();
          if (columnHtml) return $('<div className="dragging-container">' + columnHtml.trim() + '</div>');
          else return $('<div></div>');
        },
        refreshPositions: true,
        distance: 10,
        appendTo: 'body',
        cursorAt: {
          top: -12,
          left: -20,
        },
        cancel: '.dropdown',
        containment: nextProps.bounds,
        scroll: true,
      });

      $(this.refCol.current).droppable({
        drop: this.onDrop.bind(this),
        accept: acceptHash,
        tolerance: 'pointer',
        hoverClass: 'dropHover',
      });

      $(this.refCol.current).dblclick(function () {});
    }
  }

  handleResize(e, { size }) {
    e.stopPropagation();
    const { context } = this.props;
    const { index } = this.props;
    let { columns } = context;
    let column = columns[index];
    column.width = size.width;
    context.setState({ columns }, false);
  }

  onResizeStop() {
    const { context } = this.props;
    context.saveConfig();
  }

  render() {
    const { column, index, hasFilter } = this.props;
    const { width, minWidth } = column;
    const { context } = this.props;
    const { hash } = context;

    if (!column.show) return <th style={{ display: 'none' }}>{hasFilter && <GridFilter {...this.props} />}</th>;

    return (
      <Resizable
        width={width}
        height={0}
        minConstraints={[minWidth]}
        onResize={this.handleResize}
        onResizeStop={this.onResizeStop}
      >
        <th
          ref={this.refCol}
          className="dynamic-table-header"
          style={{ width: width + 'px', position: 'sticky', top: '0', zIndex: '999', borderBottomWidth: '0px' }}
          data-hash={hash}
          data-index={index}
          data-field={column.fieldName}
          data-name={column.dataName}
        >
          <i className="fa fa-angle-double-up" />
          <div className="table-header-container" title={'Reposicionar Coluna'}>
            <label>{column.fieldName}</label>
            {hasFilter &&
              (column.removeFilter ? (
                <span style={{ display: 'none' }}>
                  <GridFilter {...this.props} />
                </span>
              ) : (
                <GridFilter {...this.props} />
              ))}
          </div>
        </th>
      </Resizable>
    );
  }
}

export default withGridContext(GridHeader);
